import { render } from "./sharing-prompt.vue?vue&type=template&id=2f7ddcef"
import script from "./sharing-prompt.vue?vue&type=script&lang=js"
export * from "./sharing-prompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__